import type { ReactNode } from 'react'
import { Field, FieldDescription, FieldLabel, FieldMessage } from './Field'
import { Input, type InputProps } from './Input'

export interface TextFieldProps extends InputProps {
  label?: ReactNode | undefined
  error?: string | undefined
  hint?: ReactNode | undefined
}

export function TextField({ label, error, hint, id, ...props }: TextFieldProps) {
  const inputId =
    id ?? (typeof label === 'string' ? label.toLowerCase().replace(/\s+/g, '-') : undefined)

  return (
    <Field>
      {label ? (
        inputId ? (
          <FieldLabel htmlFor={inputId}>{label}</FieldLabel>
        ) : (
          <FieldLabel>{label}</FieldLabel>
        )
      ) : null}
      <Input
        id={inputId}
        aria-invalid={error ? true : undefined}
        className={error ? 'border-red-400 focus:ring-red-400' : undefined}
        {...props}
      />
      {hint && !error ? <FieldDescription>{hint}</FieldDescription> : null}
      <FieldMessage>{error}</FieldMessage>
    </Field>
  )
}
